export default {
  search: {
    pageTitle: 'Search'
  }
}
